import React, {FC} from 'react'
import {Link} from "react-router-dom";
import {KTIcon} from "../../../../_metronic/helpers";
import {separateFormatter} from "../../../utils/separateFormatter";
import {MyTooltip} from "../tooltip/Tooltip";
import {INewsItem} from "../../../types/news";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import moment from "moment";
import {useIntl} from "react-intl";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_NEWS} from "../../../mock/URLs";
import imgBaseUrl from "../../../utils/imgBaseUrl";

type NewsCardProps = {
  newsItem: INewsItem
  refetchNews?: () => void
}

export const NewsCard: FC<NewsCardProps> = ({newsItem, refetchNews}) => {
  const {formatMessage} = useIntl()
  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_NEWS, id, refetchNews);
  };

  return (
      <div>
        <div className="card p-0">
          <div className="card-header p-0">
            <div className="card-img position-relative">
              <img src={imgBaseUrl(newsItem?.banner) || PLACEHOLDER_IMAGE_URL} alt={newsItem?.title}
                   className="card-img-top img-fluid w-100 h-150px object-fit-cover"/>
              <MyTooltip title={formatMessage({id: "Ko'rishlar soni"})} position="top">
              <span className="badge badge-light mb-2 position-absolute z-3 top-0 start-0 m-2"><KTIcon iconName={"eye"}
                                                                                                       className={"pe-2"}/>{separateFormatter(newsItem?.view_count!, " ", "")}</span>
              </MyTooltip>
            </div>
          </div>

          <div className="card-body p-3">
            <h5 className="card-title fw-bold text-dark mb-2 text-truncate">{newsItem?.title}</h5>
            <p className="text-muted mb-0 fs-7">{moment(newsItem?.created_at!).format("DD.MM.YYYY HH:mm:ss")}</p>
          </div>

          <div className={"card-footer p-3 d-flex justify-content-between"}>
            <Link to={`/news/update/${newsItem?.id}`} className={"btn btn-sm btn-light-primary"}>
              <KTIcon iconName={"pencil"} className={"fs-4"}/>
              {formatMessage({id: "Tahrirlash"})}
            </Link>
            <MyTooltip title={formatMessage({id: "O'chirish"})} position="top">
              <button className="btn btn-icon btn-danger btn-sm me-1" onClick={() => {
                handleDeleteClick(newsItem.id)
              }}>
                <KTIcon iconName={"trash-square"} className={"pe-0 fs-3"}/>
              </button>
            </MyTooltip>
          </div>
        </div>
      </div>

  )
}
